import { makeStyles } from '@material-ui/core/styles';

export const useTakisLinkStyle = makeStyles(theme => ({
    root: {
        color: theme.palette.white,
        fontFamily: 'FuturaStd, Arial',
        fontSize: '1.625rem',
        letterSpacing: '0.033rem',
        lineHeight: '2.25rem',
        textDecoration: 'none',
        padding: '0.375rem',

        '&:hover': {
            color: theme.palette.yellow,
        },
        '&:active': {
            color: theme.palette.yellow,
        },
        '&:focus': {
            color: theme.palette.yellow,
            backgroundColor: theme.palette.darkPurple,
            textDecoration: 'none',
            outline: 'none'
        },
    },
}));

export const useVariationsLinkStyle = makeStyles({
    CtaLink: {
        fontFamily: 'Veneer, Arial',
        fontSize: '2.25rem',
        lineHeight: '2.25rem',
        letterSpacing: '0.06rem',
        display: 'flex',
        alignItems: 'center',
    },

    linkSpan: {
        display: 'inline-block',
        position: 'relative',
        marginRight: 14
    }
});
